// extracted by mini-css-extract-plugin
export default {"title":"MdtOnboardingStepWrapper_title__W+AGb","buttonContainer":"MdtOnboardingStepWrapper_buttonContainer__pXSb8","buttonHidden":"MdtOnboardingStepWrapper_buttonHidden__-ekcD"};